<template>
    <div class="profile-container">
        <div class="profile-banner">
            <div class="alert alert-warning text-center" role="alert">
                Warning! These are user generated assets, we do not endorse, verify or provide warranty for purchases.
            </div>
            <h2>
                {{ token.name }}
            </h2>
            <sub>
                {{ token.symbol }}
            </sub>
            <div class="container-fixed">
                <img :src="getImageSrc(token)" alt="" class="token-image">
            </div>
            <div class="details-business">
                <a :href="token.websiteUrl" target="_blank">Website</a>
                | <a :href="'https://explorer.nebulas.io/#/address/' + token.contract" target="_blank">Contract</a>
                | <a href="javascript:void(0)" @click="openLicenseModal">License</a>
            </div>
            <div v-if="contractDetails" class="details-token">
                Circulating Supply: {{ contractTokens.length }}
                | Total Supply: {{ contractDetails.supply }} 
                | Price: {{ contractDetails.price }} NAS
            </div>
            <div class="action-container">
                <button v-if="!pendingTransaction" @click="mintContractToken" class="btn btn-primary mt-4">
                    Buy
                </button>
                <button v-else disabled class="btn btn-secondary mt-4">
                    Please wait ...
                </button>
            </div>
        </div>
        <div class="container-fixed">
            <div class="profile-body">
                <div class="row justify-content-center text-center">     
                    <div v-if="contractTokens.length == 0" class="col-10">
                        <div class="no-content text-center">
                            <span v-if="false">
                                Loading ...
                            </span>
                            <span v-else>
                                No tokens available
                            </span>                 
                        </div>    
                    </div>
                    <div v-for="(contractToken, index) in contractTokens" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-4">
                        <div class="content-container mb-3">
                            <div class="content-display">
                                <img :src="token.imageUrl" alt="card image" width="60%">
                            </div>
                            <div class="content-label">                        
                                <div>
                                    DNA: {{ contractToken.dna }}
                                </div>
                                <div>
                                    {{ contractToken.owner }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'About',
    computed: {
        ...mapGetters({
            token: 'getToken',
            contractTokens: 'getContractTokens',
            contractDetails: 'getContractDetails',
            pendingTransaction: 'getPendingTransaction'
        })    
    },
    created () {
        if (!this.token.contract) {
            this.$store.dispatch('getTokenByContract', { address: this.$route.params.address });
        } 

        this.$store.dispatch('getContractDetails', { address: this.$route.params.address });
        this.$store.dispatch('getContractTokens', { address: this.$route.params.address });
    },
    methods: {
        getImageSrc (token) {
            return token.imageUrl == 'https://unsplash.com/photos/OSzlbMcf9Hg' ? 'http://cdn.onlinewebfonts.com/svg/img_199922.png' : token.imageUrl;
        },
        openLicenseModal () {
            this.$root.$emit('bv::show::modal','card-view-modal');
        },
        mintContractToken () {
            this.$store.dispatch('mintContractToken', { price: this.contractDetails.price, address: this.$route.params.address }).then(response => {
                
                if (response.message == 'success') {

                    this.$notify({
                        group: 'app',
                        title: 'Success!',
                        text: 'You purchased a new token!'
                    });

                } else {

                     this.$notify({
                        group: 'app',
                        title: 'Warning!',
                        text: 'There was a problem with your transaction!'
                    });

                }

            });
        }
    }
}
</script>

<style scoped lang="less">
.profile-body {
    padding: 0 20px;
}

.profile-banner {
    padding: 0 0 20px;
    text-align: center;
    margin-bottom: 20px;
    border-bottom: 2px solid black;
    background: #f7f7f7;

    .token-image {
        height: 300px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Profile.vue